import React from 'react';

import SearchIcon from '@mui/icons-material/Search';
import {
  TextField,
  FormControl,
  Select,
  MenuItem,
} from '@mui/material';

/**
 * ColumnNamesType
 */
export interface ColumnNamesType {
  [key: string]: string
}

/**
 * プロパティ
 */
export type FilterProps = {
  /** searchId */
  searchId: string,
  /** searchIds */
  searchIds: string[],
  /** setSearchId */
  setSearchId: (id: string) => void,
  /** columnNames */
  columnNames: ColumnNamesType,
  /** filter */
  filter: string,
  /** setFilter */
  setFilter: (filter: string) => void,
}

const Filter: React.FC<FilterProps> = ({
  searchId,
  setSearchId,
  searchIds,
  columnNames,
  filter,
  setFilter,
}) => {
  if (searchIds.length === 0) {
    return null;
  }
  return (
    <div
      style={searchIds.length > 1 ? {
        display: 'grid',
        gridTemplateColumns: '150px 1fr',
        columnGap: '20px',
      } : {}}
    >
      {searchIds.length > 1 && (
        <FormControl variant="standard" sx={{ m: 1, minWidth: 100, marginTop: '17px' }}>
          <Select
            value={searchId}
            onChange={(e) => setSearchId(e.target.value)}
            label="項目"
          >
            {searchIds.map((id) => (
              <MenuItem value={id} key={id}>
                {columnNames[id]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
      <TextField
        label={`フィルタ (${columnNames[searchId]})`}
        InputProps={{
          startAdornment: (<SearchIcon />),
        }}
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        variant="standard"
        style={{ marginRight: '10px' }}
      />
    </div>
  );
};

export default Filter;
